import * as React from "react";
import { usePopover } from "../../../store/usePopoverStore";
import Button, { type ButtonProps } from "../button";

interface PopoverProps {
  id: string;
  children: React.ReactNode;
  leftProps?: ButtonProps;
  rightProps?: ButtonProps;
}

export default function ConfirmPopover(props: PopoverProps) {
  const { id, children, leftProps, rightProps } = props;

  const popPopover = usePopover((state) => state.popPopover);

  const handleClose = () => {
    popPopover(id);
  };

  return (
    <div className="px-4 pt-3 w-[240px]">
      {!!children && children}
      <div className="float-right mb-4 mt-2">
        <Button
          className="h-[24px] leading-[24px] py-0 px-2 mr-2"
          label="취소"
          variant={"outline"}
          onClick={handleClose}
          {...leftProps}
        />
        <Button
          className="h-[24px] leading-[24px] px-2 py-0"
          label="확인"
          {...rightProps}
        />
      </div>
    </div>
  );
};
